import React, { useContext, useState } from "react";
import "./Change_Trading_Password_Modal.css";
import { Form, Modal } from "react-bootstrap";
import Orange_White_Border_Btn from "../../common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import Successfull_Modal from "../successfull_modal/Successfull_Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { forgetPassword } from "../../../../utils/apis/login/Login";
import { Context } from "../../../../utils/context";
import classNames from "classnames";

const Change_Trading_Password_Modal = (props) => {
  const {
    register,
    handleSubmit,
    getValues,
    setError,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  const { userdata } = useContext(Context);
  const email = userdata?.email;

  const togglePassword = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
    } else {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };

  const onSubmit = async (data) => {
    const payload = {
      new_password: data.new_password,
      email,
    };

    try {
      const res = await forgetPassword(payload);
      if (res?.success) {
        setModalShow(true);
        setTimeout(() => {
          navigate("/my-account");
          setModalShow(false);
          props.onHide?.(); // Close the modal after success
        }, 3000);
      } else {
        setError("new_password", { message: res?.message || "Error occurred" });
      }
    } catch (error) {
      console.error("API Error:", error);
      setError("new_password", { message: "Failed to update password" });
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="premium-password-modal "
      >
        <Modal.Header closeButton className="modal-header-custom">
          <Modal.Title className="modal-title">
            Change Trading Password
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="modal-body-custom ">
          {/* Account Info */}
          <div className="account-info ">
            <div className="account-row">
              <span className="account-label">Account:</span>
              <span className="account-value">{userdata?.customer_no || "N/A"}</span>
            </div>
            <div className="account-row">
              <span className="account-label">Email:</span>
              <span className="account-value">{email || "Not Available"}</span>
            </div>
          </div>

          {/* Form */}
          <Form className="password-form" onSubmit={handleSubmit(onSubmit)}>
            {/* New Password */}
            <Form.Group className="form-group-custom">
              <Form.Label className="form-label">New Password</Form.Label>
              <div className="password-input-wrapper">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter new password"
                  className={classNames("modern-password-input", {
                    "is-invalid": errors.new_password,
                    "is-valid": getValues("new_password") && !errors.new_password,
                  })}
                  {...register("new_password", {
                    required: "New password is required",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters",
                    },
                    pattern: {
                      value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                      message:
                        "Must contain uppercase, lowercase, and number",
                    },
                  })}
                />
                <FontAwesomeIcon
                  icon={showPassword ? faEye : faEyeSlash}
                  className="password-toggle"
                  onClick={() => togglePassword("password")}
                />
              </div>
              {errors.new_password && (
                <div className="error-message">{errors.new_password.message}</div>
              )}
            </Form.Group>

            {/* Confirm Password */}
            <Form.Group className="form-group-custom">
              <Form.Label className="form-label">Confirm New Password</Form.Label>
              <div className="password-input-wrapper">
                <Form.Control
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm new password"
                  className={classNames("modern-password-input", {
                    "is-invalid": errors.confirm_password,
                    "is-valid": getValues("confirm_password") && !errors.confirm_password,
                  })}
                  {...register("confirm_password", {
                    required: "Please confirm your password",
                    validate: (value) =>
                      value === getValues("new_password") || "Passwords do not match",
                  })}
                />
                <FontAwesomeIcon
                  icon={showConfirmPassword ? faEye : faEyeSlash}
                  className="password-toggle"
                  onClick={() => togglePassword("confirm")}
                />
              </div>
              {errors.confirm_password && (
                <div className="error-message">{errors.confirm_password.message}</div>
              )}
            </Form.Group>

            {/* Submit Button */}
            <div className="submit-wrapper">
              <Orange_White_Border_Btn
                btn_name="Update Password"
                type="submit"
                className="submit-btn text-black "
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Success Modal */}
      <Successfull_Modal
        message="Password Updated Successfully"
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Change_Trading_Password_Modal;